import { Link, useParams } from 'react-router-dom';
import { clinic, getBlogPost, getTreatment } from '../data/site.js';

export default function BlogArticlePage() {
  const { slug } = useParams();
  const post = getBlogPost(slug);

  if (!post) {
    return (
      <section className="blog-page-hero">
        <div className="container">
          <h1 className="heading-display">Article not found.</h1>
          <p className="text-body">The article you requested could not be found.</p>
          <Link to="/blog/" className="btn btn--primary">Back to blog</Link>
        </div>
      </section>
    );
  }

  const relatedTreatment = getTreatment(post.relatedTreatment);
  const articleImage = post.image || relatedTreatment?.image || '/images/hero-clinic.png';
  const articleImageAlt = post.imageAlt || relatedTreatment?.imageAlt || `${post.title} illustration`;
  const reviewer = post.reviewer || 'Dr. Mayank Shah and Dr. Deepti Shah';

  return (
    <article className="article-page">
      <header className="article-hero">
        <div className="container article-hero__inner">
          <div className="article-hero__content">
            <Link to="/blog/" className="caption article-hero__back">Blog</Link>
            <h1 className="heading-display">{post.title}</h1>
            <p className="text-body">{post.answer}</p>
            <div className="blog-card__meta">
              <span>{post.readTime}</span>
              <span>Reviewed by {reviewer}</span>
              <span>Published {post.published}</span>
              <span>Updated {post.updated}</span>
            </div>
          </div>
          <div className="article-hero__image">
            <img src={articleImage} alt={articleImageAlt} loading="eager" />
          </div>
        </div>
      </header>

      <div className="article-body">
        <div className="container article-body__grid">
          <aside className="article-takeaways" aria-label="Key takeaways">
            <p className="caption">Key takeaways</p>
            <ul>
              {post.takeaways.map((takeaway) => (
                <li key={takeaway}>{takeaway}</li>
              ))}
            </ul>
          </aside>

          <div className="article-content">
            <p className="article-answer"><strong>Short answer:</strong> {post.answer}</p>
            {post.sections.map(([heading, body]) => (
              <section key={heading}>
                <h2>{heading}</h2>
                <p>{body}</p>
              </section>
            ))}

            <section className="article-local">
              <h2>For dental patients in {clinic.locality}</h2>
              <p>
                If you are comparing dentists in {clinic.locality}, use this guide to prepare questions before you book. The safest next step still depends on an in-person dental assessment, your symptoms, medical history and the treatment options available at the clinic.
              </p>
            </section>

            <section>
              <h2>When to book an assessment</h2>
              <p>
                Online information can help you prepare questions, but it cannot diagnose your mouth. Book an appointment if symptoms are new, worsening, painful, affecting eating or making you uncertain about the safest next step.
              </p>
            </section>

            {post.faqs?.length ? (
              <section className="article-faq">
                <h2>Frequently asked questions</h2>
                <div className="article-faq__list">
                  {post.faqs.map(([question, answer]) => (
                    <details key={question}>
                      <summary>{question}</summary>
                      <p>{answer}</p>
                    </details>
                  ))}
                </div>
              </section>
            ) : null}

            <div className="article-links">
              {relatedTreatment ? <Link to={`/treatments/${relatedTreatment.slug}/`}>Read about {relatedTreatment.title}</Link> : null}
              <Link to="/#booking">Book an appointment</Link>
              <Link to="/blog/">Browse all articles</Link>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}
